// FEATURES-1 (docs/specs/features-1.md): the admin Features card's "Request infrastructure" link.
// A plain browser link to a prefilled GitHub issue for the maintainer. No server call.
import type { AdminFeature } from '@scribe/core/types';

/** Where infrastructure requests go: this repo's issue tracker (the maintainer's queue). */
export const INFRA_REQUEST_REPO = 'Umbrage-Studios/umbrage-scribe';

/** Prefilled new-issue URL for the features still waiting on infrastructure. Feature names and
 * flags only, plus the environment's host — never the admin's name or email. */
export function infraRequestUrl(features: AdminFeature[], host: string): string {
  const names = features.map((f) => f.name).join(', ');
  const lines = features.map((f) => `- [ ] **${f.name}**: \`${f.infra_flag}\`, estimated cost: ${f.cost_estimate}`);
  const body = [
    `An admin asked for infrastructure for ${features.length === 1 ? 'this feature' : 'these features'} (Admin → Features):`,
    '',
    ...lines,
    '',
    `Environment: ${host || 'unknown'}`,
    '',
    'Each flag creates AWS resources, so it needs maintainer approval and a deploy. Once it is',
    'deployed, admins switch the feature on and off in the portal (docs/specs/features-1.md).',
  ].join('\n');
  const params = new URLSearchParams({ title: `Infrastructure request: ${names}`, body });
  return `https://github.com/${INFRA_REQUEST_REPO}/issues/new?${params.toString()}`;
}
